import React from 'react';
import { DollarSign, Wallet, Clock } from 'lucide-react';

export const LandingFeatures: React.FC = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-8 text-left text-xs border-t border-zinc-800/80">
      <div className="bg-zinc-900/40 border border-zinc-800/80 p-4 rounded-xl">
        <DollarSign className="w-4 h-4 text-emerald-400 mb-2" />
        <p className="font-semibold text-white">Up to 20% Recurring Share</p>
        <p className="text-zinc-500 mt-0.5">Earn continuous revenue share on every monthly subscription renewal</p>
      </div>
      <div className="bg-zinc-900/40 border border-zinc-800/80 p-4 rounded-xl">
        <Wallet className="w-4 h-4 text-indigo-400 mb-2" />
        <p className="font-semibold text-white">Local Automated Payouts</p>
        <p className="text-zinc-500 mt-0.5">Prompt withdrawals directly to bKash, Nagad, Rocket, or Bangladeshi banks</p>
      </div>
      <div className="bg-zinc-900/40 border border-zinc-800/80 p-4 rounded-xl">
        <Clock className="w-4 h-4 text-amber-400 mb-2" />
        <p className="font-semibold text-white">60-Day Attribution Window</p>
        <p className="text-zinc-500 mt-0.5">Get credited even if a merchant signs up weeks after clicking your link</p>
      </div>
    </div>
  );
};
